{% block prems_discount_category_detail %}
    <sw-page class="prems-discount-category-detail">
        {% block prems_discount_category_detail_header %}
        <template #smart-bar-header>
            <h2>
                {{ placeholder(discountCategory, 'name', $tc('prems-discount-category.detail.title')) }}
            </h2>
        </template>
        {% endblock %}

        {% block prems_discount_category_detail_actions %}
        <template #smart-bar-actions>
            {% block prems_discount_category_detail_actions_abort %}
            <mt-button
                variant="secondary"
                size="default"
                :disabled="isLoading"
                @click="onCancel"
            >
                {{ $tc('prems-discount-category.detail.button.cancel') }}
            </mt-button>
            {% endblock %}
            <sw-button-group
                class="prems-discount-category-detail__save-button-group"
                :split-button="true"
            >
                {% block prems_discount_category_detail_actions_save %}
                <sw-button-process
                    class="prems-discount-category-detail__save-action"
                    variant="primary"
                    size="default"
                    :is-loading="isLoading"
                    :process-success="isSaveSuccessful"
                    :disabled="isLoading"
                    @update:process-success="saveFinish"
                    @click.prevent="onSave"
                >
                    {{ $tc('prems-discount-category.detail.button.save') }}
                </sw-button-process>
                {% endblock %}
            </sw-button-group>
        </template>
        {% endblock %}

        {% block prems_discount_category_detail_language_switch %}
        <template #language-switch>
            <sw-language-switch
                :save-changes-function="saveOnLanguageChange"
                :abort-change-function="abortOnLanguageChange"
                @on-change="onChangeLanguage"
            />
        </template>
        {% endblock %}

        {% block prems_discount_category_detail_content %}
        <template #content>
            <div class="prems-discount-category-detail__content">
                <sw-card-view slot="content">
                    {% block prems_discount_category_detail_tabs %}
                    <sw-tabs>
                        {# Base tab #}
                        {% block prems_discount_category_detail_base %}
                        <sw-tabs-item
                            :route="getRouteForView('base')"
                            :title="$tc('prems-discount-category.detail.tabs.base')"
                        >
                            {{ $tc('prems-discount-category.detail.tabs.base') }}
                        </sw-tabs-item>
                        {% endblock %}
                        {# Discount tab #}
                        {% block prems_discount_category_detail_discount %}
                        <sw-tabs-item
                            :route="getRouteForView('discount')"
                            :title="$tc('prems-discount-category.detail.tabs.discount')"
                        >
                            {{ $tc('prems-discount-category.detail.tabs.discount') }}
                        </sw-tabs-item>
                        {% endblock %}
                        {# Restriction tab #}
                        {% block prems_discount_category_detail_settings %}
                        <sw-tabs-item
                            :route="getRouteForView('restriction')"
                            :title="$tc('prems-discount-category.detail.tabs.restriction')"
                        >
                            {{ $tc('prems-discount-category.detail.tabs.restriction') }}
                        </sw-tabs-item>
                        {% endblock %}
                        {% block prems_discount_category_detail_statistics %}
                        <sw-tabs-item
                            :route="getRouteForView('statistics')"
                            :title="$tc('prems-discount-category.detail.tabs.statistics')"
                        >
                            {{ $tc('prems-discount-category.detail.tabs.statistics') }}
                        </sw-tabs-item>
                        {% endblock %}
                    </sw-tabs>
                    {% endblock %}
                    <router-view
                        v-if="discountCategory"
                        :is-loading="isLoading"
                        :discountCategory="discountCategory"
                    />
                </sw-card-view>
            </div>
        </template>
        {% endblock %}
    </sw-page>
{% endblock %}